// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 715 ? "vendors" : chunkId) + "." + {"707":"5b0ecbc956ea9e96d0a6","715":"e9d695db54bcd2eced5e"}[chunkId] + ".js";
};